import initialState from '../../data/category';
import ActionTypes from '../constants/action-types';

const CategoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_CATEGORIES:
            return {
                ...state,
                categories: [
                    ...action.payload
                ]
            };

        case ActionTypes.SET_CATEGORIES_IS_BUSY:
            return {
                ...state,
                isBusy: action.payload
            };

        case ActionTypes.SET_CATEGORIES_HAS_MORE:
            return {
                ...state,
                hasMore: action.payload
            };

        case ActionTypes.RESET_CATEGORIES:
            let payload = {
                categories: [],
                hasMore: true
            };
            return {
                ...state,
                ...payload
            };

        case ActionTypes.SET_HAS_MORE:
            return {
                ...state,
                hasMore: action.payload
            };

        case ActionTypes.SET_CATEGORIES_MODE:
            return {
                ...state,
                mode: action.payload
            };

        case ActionTypes.SET_OLD_CATEGORY:
            return {
                ...state,
                oldCategories: action.payload
            };


        default: return state;
    }
};

export default CategoryReducer;